import React, { useMemo, useRef } from 'react';
import noop from 'lodash/noop';
import { DatePicker as AntDatePicker } from 'antd';
import styles from './styles/Calendar.less';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';

const { RangePicker } = AntDatePicker;
const DATE = 'date';

const Calendar = ({
  defaultValue,
  disabledDate,
  onChange,
  type,
  onCalendarChange,
  forceRender,
}) => {
  const containerRef =  useRef();
  const onGetCalenderContainer = () => containerRef.current;

  if (type === DATE) {
    const extraProps = forceRender ? { key: `${defaultValue[0].format()}/${defaultValue[1].format()}` } : {};
    return (<>
      <div ref={containerRef} style={{ top: 120, position: 'relative' }} />
      <RangePicker
        allowEmpty={[false,false]}
        // defaultPickerValue={[moment().add(-1, 'month'), moment()]}
        value={defaultValue}
        separator={<ArrowRightOutlined/>}
        onChange={onChange}
        disabledDate={disabledDate}
        popupClassName={styles.calendar}
        onCalendarChange={onCalendarChange}
        open
        getPopupContainer={onGetCalenderContainer}
        placement={"bottomRight"}
        {...extraProps}
      />
    </>);
  }

  return (<>
    <div ref={containerRef} style={{ top: 120, position: 'relative' }} />
    <AntDatePicker
      value={defaultValue[0]}
      onChange={onChange}
      popupClassName={styles.calendar}
      disabledDate={disabledDate}
      open
      showToday={false}
      getPopupContainer={onGetCalenderContainer}
    />
  </>);
};

Calendar.defaultProps = {
  defaultValue: [],
  disabledDate: noop,
  onChange: noop,
  onCalendarChange: noop,
  type: 'date',
  forceRender: false,
};

export default Calendar;
